// extracted by mini-css-extract-plugin
export var container = "gQ_f";
export var description = "gQ_c";
export var logoContainer = "gQ_mM";
export var socialsContainer = "gQ_pm";